var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-block-discussion",
    },
    [
      _vm.commentable
        ? _c("courseware-call-to-action-box", {
            attrs: {
              iconShape: "chat",
              actionTitle: _vm.callToActionTitleComments,
              titleClosed: _vm.text.comments.titleClosed,
              titleOpen: _vm.text.comments.titleOpen,
              foldable: true,
              open: false,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "content",
                  fn: function fn() {
                    return [
                      _c("courseware-block-comments", {
                        attrs: {
                          block: _vm.block,
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              202361752
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showFeedback
        ? _c("courseware-call-to-action-box", {
            attrs: {
              iconShape: "exclaim-circle",
              actionTitle: _vm.callToActionTitleFeedback,
              titleClosed: _vm.text.feedback.titleClosed,
              titleOpen: _vm.text.feedback.titleOpen,
              foldable: true,
              open: _vm.displayFeedback,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "content",
                  fn: function fn() {
                    return [
                      _c("courseware-block-feedback", {
                        attrs: {
                          block: _vm.block,
                          canEdit: _vm.canEdit,
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3957377863
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }